<template>
  <div class="overlay" :style="getStyle()"></div>
</template>

<script>
import {
  FRAUD_SIGNAL_BOUNDING_BOX_COLOR_RGBA,
  NEUTRAL_SIGNAL_BOUNDING_BOX_COLOR_RGBA,
} from '@/constants/colors';

export default {
  props: {
    boundingBox: {
      type: Object,
      required: true,
    },
  },
  methods: {
    getStyle() {
      return {
        height: `${Number(this.boundingBox.height) + 2}px`,
        top: '-1px',
        left: '-1px',
        position: `absolute`,
        width: `${Number(this.boundingBox.width) + 2}px`,
        background: this.isNeutralSignal()
          ? NEUTRAL_SIGNAL_BOUNDING_BOX_COLOR_RGBA
          : FRAUD_SIGNAL_BOUNDING_BOX_COLOR_RGBA,
      };
    },
    isNeutralSignal() {
      return [
        'document-parsed-details-highlighter',
        'document-highlighter',
      ].includes(this.$route.name);
    },
  },
};
</script>
